import React, { useState } from "react";

function CgpeersMark() {
  return (
    <svg viewBox="130 105 780 780" aria-hidden="true" className="tester-dock-mark cgd-logo">
      <defs>
        <linearGradient id="cgdGold" gradientUnits="userSpaceOnUse" x1="0" y1="204" x2="0" y2="786">
          <stop offset="0" stopColor="#FFD43B" />
          <stop offset=".5" stopColor="#F7B514" />
          <stop offset="1" stopColor="#E09808" />
        </linearGradient>
        <linearGradient id="cgdShine" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity="0.85" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path id="cgdA" pathLength="1" d="M406.5,785.9C364.5,785.4 359.7,785.1 351.3,783.2C281.5,767.1 234.9,713.8 229.9,644.1C228.0,617.7 229.2,363.9 231.3,351.0C238.2,308.5 256.8,274.9 287.9,248.9C314.0,227.0 340.7,213.5 371.1,206.8L381.5,204.5L526.2,204.5L670.9,204.5L673.7,206.6C676.8,208.9 677.6,210.8 692.5,247.5C697.9,260.7 706.5,280.9 711.7,292.5C723.1,317.7 722.9,317.2 719.7,320.4L717.1,323.0L558.3,323.0C460.1,323.0 396.9,323.4 392.7,324.0C371.3,327.1 354.7,343.9 351.0,366.2C349.3,377.1 349.7,619.9 351.5,628.4C353.5,637.9 356.3,643.2 363.3,650.6C374.8,663.0 382.7,664.9 420.1,665.0C438.4,665.0 441.0,665.2 442.7,666.8C443.8,667.7 455.0,684.5 467.6,704.0C480.2,723.5 496.2,748.2 503.2,758.8C522.2,787.4 522.9,786.5 481.5,786.5C465.6,786.5 431.8,786.2 406.5,785.9Z" />
        <path id="cgdB" pathLength="1" d="M577.0,785.9C569.4,785.1 568.0,784.0 561.9,773.6C555.0,762.0 527.3,718.4 510.2,692.4C502.9,681.4 497.0,671.4 497.0,670.2C497.0,664.9 494.9,665.0 580.5,665.0C681.2,665.0 681.1,665.0 692.7,652.7C702.9,642.0 702.5,644.2 702.8,598.7C703.0,569.4 702.8,558.4 701.9,557.4C700.9,556.2 687.2,556.0 613.4,556.0L526.1,556.0L524.6,553.8C521.9,550.0 522.2,460.2 524.9,456.9L526.8,454.5L667.9,454.2L808.9,454.0L810.2,456.2C811.9,459.2 812.6,604.9 811.1,634.5C808.7,680.6 795.8,711.3 767.1,740.0C740.4,766.5 710.9,781.1 676.0,785.0C665.6,786.1 585.9,786.9 577.0,785.9Z" />
        <clipPath id="cgdClip">
          <use href="#cgdA" xlinkHref="#cgdA" />
          <use href="#cgdB" xlinkHref="#cgdB" />
        </clipPath>
        <path id="cgdStar" d="M0,-1 L.22,-.22 L1,0 L.22,.22 L0,1 L-.22,.22 L-1,0 L-.22,-.22Z" />
      </defs>
      <style>{`
        .cgd-logo { overflow: visible; animation: cgd-glow 3.2s ease-in-out 2.2s infinite alternate; filter: drop-shadow(0 0 10px rgba(255,185,30,.25)); }
        .cgd-logo .float { animation: cgd-float 4.2s ease-in-out 2.4s infinite; }
        .cgd-logo .hit { transform-box: view-box; transform-origin: 520px 495px; animation: cgd-hit .45s ease-out 1.84s both; }
        .cgd-logo .fill { fill: url(#cgdGold); animation: cgd-fill 1s ease-out .9s both; }
        .cgd-logo .line { fill: none; stroke: #FFE28A; stroke-width: 5; stroke-linecap: round; stroke-linejoin: round; stroke-dasharray: 1 1; stroke-dashoffset: 0; opacity: 0; }
        .cgd-logo .a .line { animation: cgd-draw 2s ease-in-out 0s both; }
        .cgd-logo .b .line { animation: cgd-draw 2s ease-in-out .15s both; }
        .cgd-logo .a { animation: cgd-slamA 2s linear both; }
        .cgd-logo .b { animation: cgd-slamB 2s linear both; }
        .cgd-logo .shine { fill: url(#cgdShine); transform: translateX(100px) skewX(-20deg); animation: cgd-shine 5s ease-in-out 2.2s infinite; }
        .cgd-logo .ring { fill: none; stroke: #FFC93C; stroke-width: 6; opacity: 0; transform-box: fill-box; transform-origin: center; animation: cgd-ring .9s cubic-bezier(.1,.7,.3,1) 1.84s forwards; }
        .cgd-logo .spark { stroke: #FFF3C4; stroke-width: 9; stroke-linecap: round; opacity: 0; transform-box: fill-box; transform-origin: center; animation: cgd-spark .5s ease-out 1.84s forwards; }
        .cgd-logo .star { fill: #FFF1B8; opacity: 0; transform-box: fill-box; transform-origin: center; animation: cgd-twinkle 2.8s ease-in-out infinite; }
        .cgd-logo .s1 { animation-delay: 2.4s } .cgd-logo .s2 { animation-delay: 3.1s }
        .cgd-logo .s3 { animation-delay: 3.8s } .cgd-logo .s4 { animation-delay: 4.4s }
        @keyframes cgd-draw { 0% { stroke-dashoffset: 1; opacity: 1 } 62% { stroke-dashoffset: 0; opacity: 1 } 78% { opacity: .9 } 100% { stroke-dashoffset: 0; opacity: 0 } }
        @keyframes cgd-fill { from { opacity: 0 } to { opacity: 1 } }
        @keyframes cgd-slamA { 0%,72% { transform: translate(-26px,16px); animation-timing-function: cubic-bezier(.6,0,.9,.45) } 92%,100% { transform: translate(0,0) } }
        @keyframes cgd-slamB { 0%,72% { transform: translate(26px,-16px); animation-timing-function: cubic-bezier(.6,0,.9,.45) } 92%,100% { transform: translate(0,0) } }
        @keyframes cgd-hit { 0% { transform: translate(0,0) scale(1) } 20% { transform: translate(5px,-3px) scale(1.04) } 45% { transform: translate(-3px,2px) scale(.99) } 70% { transform: translate(1px,-1px) scale(1.01) } 100% { transform: translate(0,0) scale(1) } }
        @keyframes cgd-ring { from { opacity: .8; transform: scale(.45); stroke-width: 14 } to { opacity: 0; transform: scale(1.25); stroke-width: 2 } }
        @keyframes cgd-spark { 0% { opacity: 1; transform: scale(.3,.3) } 30% { opacity: 1; transform: scale(1,1.1) } 100% { opacity: 0; transform: scale(1.2,1.2) } }
        @keyframes cgd-shine { 0% { transform: translateX(100px) skewX(-20deg) } 24%,100% { transform: translateX(1200px) skewX(-20deg) } }
        @keyframes cgd-twinkle { 0%,55%,100% { opacity: 0; transform: scale(0) rotate(0) } 28% { opacity: 1; transform: scale(1) rotate(45deg) } }
        @keyframes cgd-float { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-9px) } }
        @keyframes cgd-glow { from { filter: drop-shadow(0 0 8px rgba(255,185,30,.2)) } to { filter: drop-shadow(0 0 26px rgba(255,185,30,.6)) } }
        @media (prefers-reduced-motion: reduce) {
          .cgd-logo, .cgd-logo * { animation: none !important; }
          .cgd-logo .shine, .cgd-logo .ring, .cgd-logo .spark, .cgd-logo .star, .cgd-logo .line { display: none; }
        }
      `}</style>
      <g className="float">
        <circle className="ring" cx="520" cy="495" r="300" />
        <g className="hit">
          <g className="a">
            <use className="fill" href="#cgdA" xlinkHref="#cgdA" />
            <use className="line" href="#cgdA" xlinkHref="#cgdA" />
          </g>
          <g className="b">
            <use className="fill" href="#cgdB" xlinkHref="#cgdB" />
            <use className="line" href="#cgdB" xlinkHref="#cgdB" />
          </g>
          <g clipPath="url(#cgdClip)">
            <rect className="shine" x="0" y="100" width="130" height="800" />
          </g>
          <line className="spark" x1="472" y1="667" x2="543" y2="782" />
        </g>
        <g transform="translate(722 206) scale(30)">
          <use className="star s1" href="#cgdStar" xlinkHref="#cgdStar" />
        </g>
        <g transform="translate(232 590) scale(20)">
          <use className="star s2" href="#cgdStar" xlinkHref="#cgdStar" />
        </g>
        <g transform="translate(806 640) scale(24)">
          <use className="star s3" href="#cgdStar" xlinkHref="#cgdStar" />
        </g>
        <g transform="translate(330 250) scale(16)">
          <use className="star s4" href="#cgdStar" xlinkHref="#cgdStar" />
        </g>
      </g>
    </svg>
  );
}

function RipperMark() {
  return (
    <svg viewBox="87 143 480 480" aria-hidden="true" className="tester-dock-mark tdd-logo">
      <defs>
        <linearGradient id="tddOrange" gradientUnits="userSpaceOnUse" x1="0" y1="175" x2="0" y2="475">
          <stop offset="0" stopColor="#FF6A2B" />
          <stop offset=".55" stopColor="#FF5314" />
          <stop offset="1" stopColor="#EC470B" />
        </linearGradient>
        <linearGradient id="tddWhite" gradientUnits="userSpaceOnUse" x1="0" y1="287" x2="0" y2="592">
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#ECECF1" />
        </linearGradient>
        <linearGradient id="tddShineW" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity="0.8" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="tddShineO" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#FF5314" stopOpacity="0" />
          <stop offset=".5" stopColor="#FF5314" stopOpacity="0.45" />
          <stop offset="1" stopColor="#FF5314" stopOpacity="0" />
        </linearGradient>
        <path id="tddO" pathLength="1" d="M200 252 L330 175 L492 268 L492 475 L365 408 L365 347 L360 345 Z" />
        <path id="tddW" pathLength="1" d="M163 287 L298 365 L298 410 L460 512 L330 592 L163 490 Z" />
        <clipPath id="tddClipO">
          <use href="#tddO" xlinkHref="#tddO" />
        </clipPath>
        <clipPath id="tddClipW">
          <use href="#tddW" xlinkHref="#tddW" />
        </clipPath>
        <path id="tddStar" d="M0,-1 L.22,-.22 L1,0 L.22,.22 L0,1 L-.22,.22 L-1,0 L-.22,-.22Z" />
      </defs>
      <style>{`
        .tdd-logo { overflow: visible; filter: drop-shadow(0 0 8px rgba(255,83,20,.25)); animation: tdd-glow 3.2s ease-in-out 2.2s infinite alternate; }
        .tdd-logo .float { animation: tdd-float 4.2s ease-in-out 2.4s infinite; }
        .tdd-logo .hit { transform-box: view-box; transform-origin: 327px 383px; animation: tdd-hit .45s ease-out 1.84s both; }
        .tdd-logo .fill-o { fill: url(#tddOrange); animation: tdd-fill 1s ease-out .9s both; }
        .tdd-logo .fill-w { fill: url(#tddWhite); animation: tdd-fill 1s ease-out .9s both; }
        .tdd-logo .line { fill: none; stroke-width: 3.5; stroke-linecap: round; stroke-linejoin: round; stroke-dasharray: 1 1; stroke-dashoffset: 0; opacity: 0; }
        .tdd-logo .line-o { stroke: #FF9A6B; animation: tdd-draw 2s ease-in-out 0s both; }
        .tdd-logo .line-w { stroke: #FFFFFF; animation: tdd-draw 2s ease-in-out .15s both; }
        .tdd-logo .slam-o { animation: tdd-slamO 2s linear both; }
        .tdd-logo .slam-w { animation: tdd-slamW 2s linear both; }
        .tdd-logo .loop-o { animation: tdd-loopO 5s ease-in-out 2.4s infinite; }
        .tdd-logo .loop-w { animation: tdd-loopW 5s ease-in-out 2.4s infinite; }
        .tdd-logo .shine { transform: translateX(100px) skewX(-20deg); animation: tdd-shine 5s ease-in-out 2.2s infinite; }
        .tdd-logo .ring { fill: none; stroke: #FF5314; stroke-width: 5; opacity: 0; transform-box: fill-box; transform-origin: center; animation: tdd-ring .9s cubic-bezier(.1,.7,.3,1) 1.84s forwards; }
        .tdd-logo .flash { fill: none; stroke: #FFD9C2; stroke-width: 12; stroke-linecap: round; stroke-linejoin: round; opacity: 0; animation: tdd-flash .55s ease-out 1.84s forwards; }
        .tdd-logo .runner { fill: none; stroke: #FFFFFF; stroke-width: 6; stroke-linecap: round; stroke-linejoin: round; opacity: 0; stroke-dasharray: .3 2; stroke-dashoffset: .3; animation: tdd-run .75s cubic-bezier(.4,0,.2,1) 1.84s forwards; }
        .tdd-logo .star { fill: #FFD9C2; opacity: 0; transform-box: fill-box; transform-origin: center; animation: tdd-twinkle 2.8s ease-in-out infinite; }
        .tdd-logo .s1 { animation-delay: 2.4s } .tdd-logo .s2 { animation-delay: 3.1s }
        .tdd-logo .s3 { animation-delay: 3.8s } .tdd-logo .s4 { animation-delay: 4.4s }
        @keyframes tdd-draw { 0% { stroke-dashoffset: 1; opacity: 1 } 62% { stroke-dashoffset: 0; opacity: 1 } 78% { opacity: .9 } 100% { stroke-dashoffset: 0; opacity: 0 } }
        @keyframes tdd-fill { from { opacity: 0 } to { opacity: 1 } }
        @keyframes tdd-slamO { 0%,72% { transform: translate(17px,-30px); animation-timing-function: cubic-bezier(.6,0,.9,.45) } 92%,100% { transform: translate(0,0) } }
        @keyframes tdd-slamW { 0%,72% { transform: translate(-17px,30px); animation-timing-function: cubic-bezier(.6,0,.9,.45) } 92%,100% { transform: translate(0,0) } }
        @keyframes tdd-loopO { 0%,100% { transform: translate(0,0) } 50% { transform: translate(13px,7.5px) } }
        @keyframes tdd-loopW { 0%,100% { transform: translate(0,0) } 50% { transform: translate(-13px,-7.5px) } }
        @keyframes tdd-hit { 0% { transform: translate(0,0) scale(1) } 20% { transform: translate(4px,-3px) scale(1.035) } 45% { transform: translate(-3px,2px) scale(.99) } 70% { transform: translate(1px,-1px) scale(1.01) } 100% { transform: translate(0,0) scale(1) } }
        @keyframes tdd-ring { from { opacity: .85; transform: scale(.45); stroke-width: 12 } to { opacity: 0; transform: scale(1.25); stroke-width: 2 } }
        @keyframes tdd-flash { 0% { opacity: 1 } 100% { opacity: 0 } }
        @keyframes tdd-run { 0% { opacity: 1; stroke-dashoffset: .3 } 85% { opacity: 1 } 100% { opacity: 0; stroke-dashoffset: -1.05 } }
        @keyframes tdd-shine { 0% { transform: translateX(100px) skewX(-20deg) } 24%,100% { transform: translateX(780px) skewX(-20deg) } }
        @keyframes tdd-twinkle { 0%,55%,100% { opacity: 0; transform: scale(0) rotate(0) } 28% { opacity: 1; transform: scale(1) rotate(45deg) } }
        @keyframes tdd-float { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-7px) } }
        @keyframes tdd-glow { from { filter: drop-shadow(0 0 6px rgba(255,83,20,.18)) } to { filter: drop-shadow(0 0 22px rgba(255,83,20,.55)) } }
        @media (prefers-reduced-motion: reduce) {
          .tdd-logo, .tdd-logo * { animation: none !important; }
          .tdd-logo .shine, .tdd-logo .ring, .tdd-logo .flash, .tdd-logo .runner, .tdd-logo .star, .tdd-logo .line { display: none; }
        }
      `}</style>
      <g className="float">
        <circle className="ring" cx="327" cy="383" r="170" />
        <g className="hit">
          <g className="slam-o">
            <g className="loop-o">
              <use className="fill-o" href="#tddO" xlinkHref="#tddO" />
              <use className="line line-o" href="#tddO" xlinkHref="#tddO" />
              <g clipPath="url(#tddClipO)">
                <rect className="shine" x="0" y="100" width="80" height="560" fill="url(#tddShineW)" />
              </g>
            </g>
          </g>
          <g className="slam-w">
            <g className="loop-w">
              <use className="fill-w" href="#tddW" xlinkHref="#tddW" />
              <use className="line line-w" href="#tddW" xlinkHref="#tddW" />
              <g clipPath="url(#tddClipW)">
                <rect className="shine" x="0" y="100" width="80" height="560" fill="url(#tddShineO)" />
              </g>
            </g>
          </g>
          <polyline className="flash" points="181,270 332,357 332,409 476,493" />
          <polyline className="runner" pathLength="1" points="181,270 332,357 332,409 476,493" />
        </g>
        <g transform="translate(330 172) scale(20)">
          <use className="star s1" href="#tddStar" xlinkHref="#tddStar" />
        </g>
        <g transform="translate(496 262) scale(15)">
          <use className="star s2" href="#tddStar" xlinkHref="#tddStar" />
        </g>
        <g transform="translate(160 482) scale(17)">
          <use className="star s3" href="#tddStar" xlinkHref="#tddStar" />
        </g>
        <g transform="translate(332 596) scale(13)">
          <use className="star s4" href="#tddStar" xlinkHref="#tddStar" />
        </g>
      </g>
    </svg>
  );
}

export default function AppSwitcherBar({ mode, onChange }) {
  const [replay, setReplay] = useState({ cgpeers: 0, ripper: 0 });

  const select = (next) => {
    onChange(next);
    setReplay((prev) => ({ ...prev, [next]: prev[next] + 1 }));
  };

  return (
    <nav className="tester-app-dock" aria-label="Переключение приложения">
      <div className="tester-app-dock-pill">
        <span className={`tester-app-dock-glow ${mode}`} aria-hidden="true" />
        <button
          type="button"
          className={mode === "cgpeers" ? "is-active" : ""}
          aria-pressed={mode === "cgpeers"}
          aria-label="CGPeers"
          onClick={() => select("cgpeers")}
        >
          <CgpeersMark key={replay.cgpeers} />
        </button>
        <button
          type="button"
          className={mode === "ripper" ? "is-active" : ""}
          aria-pressed={mode === "ripper"}
          aria-label="3DRipper"
          onClick={() => select("ripper")}
        >
          <RipperMark key={replay.ripper} />
        </button>
      </div>
    </nav>
  );
}
